<template>
  <div class="container" v-title data-title="快速了解教师联盟">
    <div class="container-content">
      <img class="bg" src="../../assets/circle/introduce.png" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'CircleIntroduce',
  data() {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
// 父容器
.container {
  min-height: 100vh;
  height: 100%;
  width: 100vw;
  background-color: #e8fbfcff;

  // 内容
  .container-content {
    display: block;
    position: relative;
    // 背景
    .bg {
      width: 100%;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/circle/Introduce.vue